import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { I18NextService } from 'angular-i18next';
import { WorkflowArea } from '../../enums/workflow-area.enum';

@Component({
    selector: 'export-documents-zip-filter-dropdown',
    templateUrl: './export-documents-zip-filter-dropdown.component.html',
    styleUrls: ['./export-documents-zip-filter-dropdown.component.scss'],
})
export class ExportDocumentsZipFilterDropDown {
    @Input() selectedWorkflowAreas: WorkflowArea[] = [];
    @Output() exportZipClicked = new EventEmitter<WorkflowArea[]>();

    public openedFlyout = false;

    public flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    public documentsOptions = [
        { label: 'Mandate Management Documents', value: WorkflowArea.MANDATE_MANAGEMENT },
        {
            label: 'Closing Workflow Documents',
            value: WorkflowArea.CLOSING_PROCESS,
        },
    ];

    constructor(private readonly localizedTexts: I18NextService) {
        this.documentsOptions[0].label = this.localizedTexts.t(
            'aumico_reports_cpmm_export_documents_zip_mandate_management_documents',
        ) as string;
        this.documentsOptions[1].label = this.localizedTexts.t(
            'aumico_reports_cpmm_export_documents_zip_closing_workflow_documents',
        ) as string;
    }

    onStatusSelection(value: WorkflowArea, checked: boolean) {
        if (checked) {
            this.selectedWorkflowAreas.push(value);
        } else {
            this.selectedWorkflowAreas = this.selectedWorkflowAreas.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 4,
            right: rect.right,
            left: rect.left,
        };

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    exportZip(): void {
        this.exportZipClicked.emit(this.selectedWorkflowAreas);
    }
}
